import api from '@/axios'

export default {
  findAll () {
    return api().get('track')
  },
  findOne (id) {
    return api().get(`admin/track/${id}`)
  },
  create (data) {
    return api().post('admin/track/add', data)
  },
  update (id, data) {
    return api().patch(`admin/track/${id}`, data)
  },
  remove (id) {
    return api().delete(`track/${id}`)
  }
}
